import { ShoppingCart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { useCart } from '../context/CartContext';
import { orderPath } from '../lib/orderPath';

export default function FloatingCartButton() {
  const navigate = useNavigate();
  const { getCartCount, getCartTotal } = useCart();
  
  const itemCount = getCartCount();
  const total = getCartTotal();

  if (itemCount === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <Button
        onClick={() => navigate(orderPath('cart'))}
        className="h-16 px-6 bg-blue-600 hover:bg-blue-700 shadow-2xl rounded-full flex items-center gap-3"
      >
        <div className="relative">
          <ShoppingCart className="h-6 w-6" />
          <Badge className="absolute -top-2 -right-2 h-5 min-w-[20px] flex items-center justify-center bg-red-500 text-white text-xs p-0 px-1">
            {itemCount}
          </Badge>
        </div>
        <div className="flex flex-col items-start">
          <span className="text-xs opacity-90">View Cart</span>
          <span className="font-bold">${total.toFixed(2)}</span>
        </div>
      </Button>
    </div>
  );
}
